/**
 *  UserModal.jsx
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 05/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

 // system
import React, { Component } from "react";

// template
import { Modal, Button } from "react-bootstrap";

// global
var firebase = require("../../firebase");

export class UserModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            url: null,
            lastLocationUpdate: null
        };
    }

    closeModal = () => {
        this.props.handleHide();
    }

    timeFormatter = () => {
        const { rowSelected  } = this.props;
        let d = new Date(rowSelected.lastLocationUpdate);
        const time = (
        ("00" + d.getDate()).slice(-2) + "/" + 
        ("00" + (d.getMonth() + 1)).slice(-2) + "/" + 
        d.getFullYear() + " " + 
        ("00" + d.getHours()).slice(-2) + ":" + 
        ("00" + d.getMinutes()).slice(-2) + ":" + 
        ("00" + d.getSeconds()).slice(-2));

        return time;
    }

    modalMap(){
        const { url } = this.props;

        if (url != ""){
            return (
                <div>
                    <h5 style={{fontWeight: 'bold'}}>ÚLTIMA ATUALIZAÇÃO: {this.timeFormatter()}</h5>
                    <iframe 
                        src={url}  
                        style={{ width: "100%", height: "400px", background: "transparent", border: "none"}} 
                        className=""
                    />
                </div>
            )
        } 
    }

    render() {
        

        const { show } = this.props;
        return (
            <Modal show={show}>
                <Modal.Body>
                    {this.modalMap()}
                </Modal.Body>
                <Modal.Footer>
                    <Button className='btn btn-danger' onClick={this.closeModal}>FECHAR</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default UserModal;



// WEBPACK FOOTER //
// ./src/views/Users/UserModal.jsx